import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    units: [],
    isUnitsLoading: false

}


export const getUnits = createAsyncThunk(
    'get_units_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getUnitsStart());
            const response = await axios.get(`/units/get_units.php`)
            console.log('response of units', response?.data?.data)
            if (response?.data?.status == 'success') {

                dispatch(getUnitsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getUnitsFailure(error.response.data.message))
        }
    }
)
export const addUnit = createAsyncThunk(
    "addunits",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os unitsData ', data)
        try {
            dispatch(addUnitsStart());
            const response = await axios.post(`/units/add_unit.php`, data);
            dispatch(addUnitsSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getUnits())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addUnitsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteUnit = createAsyncThunk('deleteunit', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateUnitsStart());
        const response = await axios.delete(`/units/delete_units.php?id=${id}`);
        if (response?.data?.status == 'success') {
            dispatch(getUnits())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateUnit = createAsyncThunk(
    "addunits",
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log('data os unitsData ', data)
        try {
            dispatch(updateUnitsStart());
            const response = await axios.post(`/units/update_unit.php`, data);
            dispatch(updateUnitsSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getUnits())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(updateUnitsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

const unitsSlice = createSlice({
    name: 'units',
    initialState,
    reducers: {
        getUnitsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getUnitsSuccess(state, action) {

            state.units = action.payload;
            state.isLoading = false;
        },
        getUnitsFailure(state, action) {
            state.units = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addUnitsStart(state) {
            state.isUnitsLoading = true;
            state.error = null;
        },
        addUnitsSuccess(state, action) {
            state.user = action.payload;
            state.isUnitsLoading = false;
        },
        addUnitsFailure(state, action) {
            state.error = action.payload;
            state.isUnitsLoading = false;
        },

        updateUnitsStart(state) {
            state.isUnitsLoading = true;
            state.error = null;
        },
        updateUnitsSuccess(state, action) {
            state.user = action.payload;
            state.isUnitsLoading = false;
        },
        updateUnitsFailure(state, action) {
            state.error = action.payload;
            state.isUnitsLoading = false;
        },
    }
})

export const { getUnitsSuccess, getUnitsStart, getUnitsFailure, addUnitsStart, addUnitsSuccess, addUnitsFailure, updateUnitsStart, updateUnitsSuccess, updateUnitsFailure } = unitsSlice.actions;

export default unitsSlice.reducer;